// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"WordsVideoControl_buttonGroup__3kz6G","active":"WordsVideoControl_active__1yRtA","singleRepeat":"WordsVideoControl_singleRepeat__UU8Tv"};